module.exports = __webpack_public_path__ + "static/designPatterns-30d374f57f181801366813cb2a964ed8.png";